import { breakpoints, borderRadius, spacing } from '@naf/theme';
import styled from '@emotion/styled';
import { AdvancedVideo } from '@cloudinary/react';
import ResponsiveImage from '../../../../components/image/ResponsiveImage';
import { MAX_WIDTH } from '../../../../components/layout/Layout.styles';

export const INNER_MAX_WIDTH = `calc(${MAX_WIDTH} - 2 * ${spacing.space48})`;

export const StyledResponsiveImage = styled(ResponsiveImage)`
  display: block;
  object-fit: cover;
  height: 320px;
  width: 100%;
  border-radius: ${borderRadius.S};

  @media screen and (min-width: ${breakpoints.m}) {
    height: 603px;
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.l}) {
    width: calc(${INNER_MAX_WIDTH} - 125px);
    max-height: 603px;
  }
`;

export const StyledVideo = styled(AdvancedVideo)`
  display: block;
  object-fit: cover;
  height: 320px;
  width: 100%;
  border-radius: ${borderRadius.S};

  @media screen and (min-width: ${breakpoints.m}) {
    height: 603px;
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.l}) {
    width: calc(${INNER_MAX_WIDTH} - 125px);
    max-height: 603px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  border-radius: ${borderRadius.S};

  @media screen and (min-width: ${breakpoints.l}) {
    max-width: ${INNER_MAX_WIDTH};
    margin: 0 auto;
    transform: translateX(163px);

    ${StyledResponsiveImage}, ${StyledVideo} {
      display: block;
      margin-left: auto;
    }
  }
`;
